import {useState} from 'react';
import {BigFetchWithCleanPosition} from '../../../envisia/workflow/fetch/box/fetch-box.model';
import {EvButton} from '../../form/EvButton';
import {EvReactModal} from '../../modal/EvReactModal';
import {useFetchStatusChangeMutation} from './use-fetch-status-change-mutation';
import {FETCH_STATUS} from '../fetch-status.model';

const statusChangeableStates: number[] = [
  FETCH_STATUS.CONTRACT,
  FETCH_STATUS.PRODUCTION,
  FETCH_STATUS.PRODUCED,
];
const statusChangeableWithConcludedStates: number[] = [
  ...statusChangeableStates,
  FETCH_STATUS.DELIVERY,
];

interface Props {
  workflowId: number;
  fetch: BigFetchWithCleanPosition;
  hasStatusChangeRight: boolean;
  hasConcludedNotBilledRight: boolean;
  statusChanged: (status: number) => void;
}

export function FetchStatusChange(props: Props) {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const {isPending, mutateFetchStatus} = useFetchStatusChangeMutation({
    workflowId: props.workflowId,
    fetchId: props.fetch.id,
    successCallback: status => {
      setModalOpen(false);
      props.statusChanged(status);
    },
  });

  const statusChangeable = props.hasStatusChangeRight && statusChangeableStates.includes(props.fetch.status);
  const concludedNotBilledChangeable = props.hasConcludedNotBilledRight &&
    statusChangeableWithConcludedStates.includes(props.fetch.status);

  if (!statusChangeable && !concludedNotBilledChangeable) {
    return null;
  }

  return <>
    <EvButton variant="anchor"
              size="no-padding"
              className="p-2.5"
              onClick={() => setModalOpen(true)}>
      <b>Statusänderung</b>
    </EvButton>
    <EvReactModal contentLabel="Achtung!"
                  showModal={modalOpen}
                  modalClosed={() => setModalOpen(false)}>
      <div className="modal-body">
        <p>Möchten Sie wirklich den Status ändern?</p>
        <div className="flex flex-wrap gap-2">
          {statusChangeable && <>
            <EvButton variant="primary"
                      disabled={isPending}
                      onClick={() => mutateFetchStatus(FETCH_STATUS.CONTRACT)}>
              Bestätigt
            </EvButton>
            <EvButton variant="purple"
                      disabled={isPending}
                      onClick={() => mutateFetchStatus(FETCH_STATUS.PRODUCTION)}>
              In Produktion
            </EvButton>
            <EvButton variant="rose"
                      disabled={isPending}
                      onClick={() => mutateFetchStatus(FETCH_STATUS.PRODUCED)}>
              Produziert
            </EvButton>
          </>}
          {concludedNotBilledChangeable &&
            <EvButton disabled={isPending}
                      onClick={() => mutateFetchStatus(FETCH_STATUS.CONCLUDED_NOT_BILLED)}>
              Abgeschlossen / nicht Abgerechnet
            </EvButton>
          }
        </div>
      </div>
      <div className="modal-footer">
        <EvButton className="float-left" disabled={isPending}
                  onClick={() => setModalOpen(false)}>
          Abbrechen
        </EvButton>
      </div>
    </EvReactModal>
  </>;
}
